import { Province } from "../functions/types";

export const provinces: Province[] = [
    {
        shorthand: 'SS',
        name: 'Sassari',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BZ',
        name: 'Bolzano',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'FG',
        name: 'Foggia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'CN',
        name: 'Cuneo',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'TO',
        name: 'Torino',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'CS',
        name: 'Cosenza',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PZ',
        name: 'Potenza',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PG',
        name: 'Perugia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'TN',
        name: 'Trento',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'NU',
        name: 'Nuoro',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'RM',
        name: 'Roma',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'AQ',
        name: 'L\'Aquila',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PA',
        name: 'Palermo',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'UD',
        name: 'Udine',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'SA',
        name: 'Salerno',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BS',
        name: 'Brescia',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'GR',
        name: 'Grosseto',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BA',
        name: 'Bari',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'SI',
        name: 'Siena',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BO',
        name: 'Bologna',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'VT',
        name: 'Viterbo',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BL',
        name: 'Belluno',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'CT',
        name: 'Catania',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'AL',
        name: 'Alessandria',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'FI',
        name: 'Firenze',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'MT',
        name: 'Matera',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PR',
        name: 'Parma',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'ME',
        name: 'Messina',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'AO',
        name: 'Aosta/Aoste',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'FR',
        name: 'Frosinone',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'AR',
        name: 'Arezzo',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'RC',
        name: 'Reggio Calabria',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'SO',
        name: 'Sondrio',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'VR',
        name: 'Verona',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'AG',
        name: 'Agrigento',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'OR',
        name: 'Oristano',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PV',
        name: 'Pavia',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'CB',
        name: 'Campobasso',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'AV',
        name: 'Avellino',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'LE',
        name: 'Lecce',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'MC',
        name: 'Macerata',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'RI',
        name: 'Rieti',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'BG',
        name: 'Bergamo',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'VI',
        name: 'Vicenza',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'MO',
        name: 'Modena',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'CE',
        name: 'Caserta',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'FE',
        name: 'Ferrara',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'CH',
        name: 'Chieti',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'PC',
        name: 'Piacenza',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'EN',
        name: 'Enna',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PU',
        name: 'Pesaro e Urbino',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'TV',
        name: 'Treviso',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'VE',
        name: 'Venezia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'TP',
        name: 'Trapani',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'TA',
        name: 'Taranto',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PI',
        name: 'Pisa',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'CZ',
        name: 'Catanzaro',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'FC',
        name: 'Forli-Cesena',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'MN',
        name: 'Mantova',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'RE',
        name: 'Reggio Emilia',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'PN',
        name: 'Pordenone',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'VB',
        name: 'Verbano-Cusio-Ossola',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'LT',
        name: 'Latina',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PD',
        name: 'Padova',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'CL',
        name: 'Caltanissetta',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'TR',
        name: 'Terni',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'SR',
        name: 'Siracusa',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'VC',
        name: 'Vercelli',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'BN',
        name: 'Benevento',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'AN',
        name: 'Ancona',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'TE',
        name: 'Teramo',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'BR',
        name: 'Brindisi',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'RA',
        name: 'Ravenna',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'GE',
        name: 'Genova',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'RO',
        name: 'Rovigo',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'LU',
        name: 'Lucca',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'CR',
        name: 'Cremona',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'KR',
        name: 'Crotone',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'RG',
        name: 'Ragusa',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'MI',
        name: 'Milano',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'SV',
        name: 'Savona',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'BT',
        name: 'Barletta-Andria-Trani',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'IS',
        name: 'Isernia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'AT',
        name: 'Asti',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'NO',
        name: 'Novara',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'CO',
        name: 'Como',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'CA',
        name: 'Cagliari',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'SU',
        name: 'Sud Sardegna',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PE',
        name: 'Pescara',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'AP',
        name: 'Ascoli Piceno',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'LI',
        name: 'Livorno',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'VA',
        name: 'Varese',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'NA',
        name: 'Napoli',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'IM',
        name: 'Imperia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'MS',
        name: 'Massa-Carrara',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'VV',
        name: 'Vibo Valentia',
        zone: 'III',
        load: 0.6
    },
    {
        shorthand: 'PT',
        name: 'Pistoia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'BI',
        name: 'Biella',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'SP',
        name: 'La Spezia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'RN',
        name: 'Rimini',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'FM',
        name: 'Fermo',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'LC',
        name: 'Lecco',
        zone: 'I-A',
        load: 1.5
    },
    {
        shorthand: 'LO',
        name: 'Lodi',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'GO',
        name: 'Gorizia',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'MB',
        name: 'Monza e Brianza',
        zone: 'I-M',
        load: 1.5
    },
    {
        shorthand: 'PO',
        name: 'Prato',
        zone: 'II',
        load: 1
    },
    {
        shorthand: 'TS',
        name: 'Trieste',
        zone: 'II',
        load: 1
    }
]